import React, { forwardRef, useEffect, useState } from "react";
import { Form, Input } from "antd";
import UpFileSingleProp from "../UpFileSingleProp";

const ProductSeo = forwardRef((props, ref) => {
  const { TextArea } = Input;

  const [form] = Form.useForm();

  const valueForm = {
    seoTitle: null,
    seoDescription: null,
    seoKeywords: null,
  };

  const { productItem } = props;

  const [image, setImage] = useState(productItem?.seoImage || null);

  const onUploadImage = (url) => {
    setImage(url);
  };

  useEffect(() => {
    if (productItem) {
      form.setFieldsValue({
        seoTitle: productItem.seoTitle,
        seoDescription: productItem.seoDescription,
        seoKeywords: productItem.seoKeywords,
      });
    } else {
      form.setFieldsValue(valueForm);
      setImage(productItem?.seoImage);
    }
  }, [form]);

  const onFinishFailed = (errorInfo) => {
    props.onFinishFailed({
      errorFields: errorInfo.errorFields,
      name: "ProductSeo",
    });
    console.log("Failed:", errorInfo);
  };

  const onFinish = (values) => {
    // props.onSubmit(values, "ProductSeo");
    props.onSubmit({ ...values, seoImage: image }, "ProductSeo");
  };

  return (
    <>
      <Form
        form={form}
        labelCol={{
          span: 4,
        }}
        wrapperCol={{
          span: 14,
        }}
        ref={ref}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="horizontal"
        size="medium"
      >
        <Form.Item label="Ảnh Thumbnail" tooltip="Ảnh hiển thị trên social">
          <UpFileSingleProp onUploadImage={onUploadImage} image={image} />
        </Form.Item>
        <Form.Item label="Thẻ tiêu đề" name="seoTitle" tooltip="Thẻ title">
          <Input />
        </Form.Item>
        <Form.Item
          label="Mô tả meta"
          name="seoDescription"
          tooltip="Thẻ meta description"
        >
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item
          label="Từ khóa meta"
          name="seoKeywords"
          tooltip="Từ khóa meta keywords"
        >
          <Input />
        </Form.Item>
      </Form>
    </>
  );
});

export default ProductSeo;
